
$('input[type=text], input[type=email], input[type=tel], textarea', '.component-form').on('click', function() {
  $(this).data('placeholder', $(this).attr('placeholder')).attr('placeholder', '');
}).on('blur', function() {
  $(this).attr('placeholder', $(this).data('placeholder'));
});

$('.frm_checkbox').on('click', function(ev) {
  ev.preventDefault();
  var checked, input;

  input = $('input', this)[0];
  checked = input.checked;

  if (checked) {
    input.checked = false;
    $(input).parents('.frm_checkbox').removeClass('checked');
  } else {
    input.checked = true;
    $(input).parents('.frm_checkbox').addClass('checked');
  }
});

// Policy Privacy
jQuery(function() {
  var policy_privacy, policy_privacy_wrapper;

  if ($('.privacy_frm_field').length > 0) {
    policy_privacy = $("[data-policy-privacy-text='true']");
    policy_privacy_wrapper = '<div class="policy_privacy_wrapper">' + policy_privacy.html() + '<div>';
    $(policy_privacy_wrapper).insertAfter('.privacy_frm_field textarea');
    $('.privacy_frm_field textarea').remove();
  }

  if ($("[data-alert]").length > 0) {
    $("[data-alert]").each(function(index, that) {
      var $alert;

      $(that).append(["<div class='frm_alert_message frm_alert_message_", index, "'>", $(that).data('alert'), "</div>"].join(''));
      $alert = $(".frm_alert_message_" + index);
      $alert.hide();

      $('input', that).each(function() {
        $(this).on('change', function() {
          $alert.siblings('.frm_error').remove();

          if ($(this).val() === 'No') {
            $(that).css({ 'border-width': '1px', 'border-style': 'solid' });
            $alert.show();
          }

          if ($(this).val() === 'Si') {
            $(that).css('border', 'none');
            $alert.hide();
          }
        });
      });
    });
  }
});
